export default function Ajax()
{
  this.Types =
  {
    'GET': 'GET',
    'POST': 'POST'
  };

  this.ResponseTypes =
  {
    'TEXT': 1,
    'JSON': 2
  };


  this.request = (args) =>
  {
    const xhr = new XMLHttpRequest();

    xhr.open(args.type, args.url);

    if (args.dataType === this.ResponseTypes.JSON)
    {
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    }

    if (args.responseType === this.ResponseTypes.JSON && 'overrideMimeType' in xhr)
    {
      xhr.overrideMimeType("application/json");
    }

    xhr.addEventListener('load', () => args.onSuccess((args.responseType === this.ResponseTypes.JSON) ? JSON.parse(xhr.responseText.replace(/^[^{]*({[\S\s]*})[^}]*$/, '$1')) : xhr.responseText));
    xhr.addEventListener('error', () => args.onError(xhr.status));
    xhr.send((args.data !== undefined) ? args.data : null);
  };
}